import React from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '@/context/ContentContext';
import { FOOTER_B2B, FOOTER_INSTITUTIONAL } from '@/data/b2b';

const colClass = 'text-[14px] text-white/70 hover:text-ophir-gold-soft transition-colors';

export const Footer = () => {
  const { content } = useContent();
  const footer = content?.footer || {};
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-ophir-navy-deep text-white">
      <div className="container-ophir py-14 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-x-8 gap-y-10">
          <div className="md:col-span-4">
            <div data-testid="site-footer-logo" className="inline-flex bg-ophir-ivory-soft rounded-xl p-4">
              <img src="/images/ophir/logo/ophir-logo-full.png" alt="OPHIR SUPPLY — Wholesale, Distribution, Global Sourcing" className="h-14 w-auto" style={{ maxWidth: 260 }} />
            </div>
            <p className="mt-5 text-[14px] leading-relaxed text-white/70 max-w-sm">
              {footer.description}
            </p>
            <p className="mt-4 font-serif text-ophir-gold-soft text-[15px]">{footer.brand_line}</p>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-[12px] font-semibold uppercase tracking-[0.14em] text-ophir-gold-soft">Company</h4>
            <ul className="mt-4 space-y-2.5">
              <li><Link to="/about" className={colClass}>About</Link></li>
              <li><Link to="/capabilities" className={colClass}>Capabilities</Link></li>
              <li><Link to="/categories" className={colClass}>Product Categories</Link></li>
              <li><Link to="/contact" className={colClass}>Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-[12px] font-semibold uppercase tracking-[0.14em] text-ophir-gold-soft">Work With Us</h4>
            <ul className="mt-4 space-y-2.5">
              <li><Link to="/suppliers" className={colClass}>For Suppliers — Submit Your Brand</Link></li>
              <li><Link to="/buyers" className={colClass}>For Buyers — Make an Inquiry</Link></li>
              <li><Link to="/contact" className={colClass}>Discuss a Supply Opportunity</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-[12px] font-semibold uppercase tracking-[0.14em] text-ophir-gold-soft">B2B Supply</h4>
            <ul className="mt-4 space-y-2.5">
              {FOOTER_B2B.map((l) => (
                <li key={l.to}><Link to={l.to} className={colClass}>{l.label}</Link></li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-[12px] font-semibold uppercase tracking-[0.14em] text-ophir-gold-soft">Institutional Buyers</h4>
            <ul className="mt-4 space-y-2.5">
              {FOOTER_INSTITUTIONAL.map((l) => (
                <li key={l.to}><Link to={l.to} className={colClass}>{l.label}</Link></li>
              ))}
            </ul>
          </div>
        </div>

        <div className="gold-rule mt-12 opacity-50" />
        <div className="mt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-[13px] text-white/55">
          <p>&copy; {year} OPHIR SUPPLY. All rights reserved.</p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <Link to="/privacy" className="hover:text-ophir-gold-soft transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-ophir-gold-soft transition-colors">Terms of Use</Link>
            <Link to="/accessibility" className="hover:text-ophir-gold-soft transition-colors">Accessibility</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
